import React from 'react';
import cn from 'classnames';
import Image from 'components/UI/Image';

import * as styles from './videowithbackground.module.scss';

export function Component({ content, className }) {
  const { link, background } = content;
  return (
    <div className={cn(className, styles.wrapper)}>
      <Image
        className={styles.backgroundPicture}
        classImage={styles.backgroundImg}
        src={background}
      />
      <video autoPlay muted loop className={styles.video}>
        <source src={link} type="video/mp4" />
      </video>
    </div>
  );
}
